import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const ACCENT = '#F97316';

const tiposCampana = [
  { tipo: 'OFERTAS', icon: 'Tag', color: '#34D399', desc: 'Promociones y descuentos especiales' },
  { tipo: 'NOVEDADES', icon: 'Sparkles', color: '#60A5FA', desc: 'Nuevos productos y servicios' },
  { tipo: 'CUMPLEAÑOS', icon: 'Gift', color: '#F472B6', desc: 'Felicitaciones y ofertas personalizadas' },
  { tipo: 'FIDELIZACIÓN', icon: 'Heart', color: '#FBBF24', desc: 'Premiar a clientes habituales' },
  { tipo: 'REACTIVACIÓN', icon: 'RefreshCw', color: '#A78BFA', desc: 'Recuperar clientes inactivos' },
  { tipo: 'CLIENTES HABITUALES', icon: 'Star', color: ACCENT, desc: 'Comunicaciones a clientes frecuentes' },
];

const segmentacion = [
  { campo: 'Área cliente', icon: 'Layers', desc: 'Tienda / Distribución / Sala' },
  { campo: 'Familia / Productos comprados', icon: 'Package', desc: 'Jamón, embutidos, loncheados…' },
  { campo: 'Actividad', icon: 'Activity', desc: 'Activo / Inactivo / Ocasional' },
  { campo: 'Última compra', icon: 'Calendar', desc: 'Hace X días / semanas / meses' },
  { campo: 'Frecuencia', icon: 'BarChart2', desc: 'Semanal / Mensual / Esporádico' },
  { campo: 'Etiquetas', icon: 'Tag', desc: 'Etiquetas personalizadas del cliente' },
];

const ComercialCampanas = () => {
  const [tipoFiltro, setTipoFiltro] = useState('Todos');
  const tipos = ['Todos', ...tiposCampana?.map(t => t?.tipo)];

  return (
    <div className="min-h-screen px-4 py-6 md:px-8"
      style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>

      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <nav className="flex items-center gap-2 text-xs font-oranienbaum text-white/30 mb-2">
            <span>🤝 Comercial</span>
            <Icon name="ChevronRight" size={12} />
            <span className="text-white/60">Campañas</span>
          </nav>
          <div className="flex items-center gap-3 mb-1">
            <span className="text-2xl">📣</span>
            <h1 className="font-oranienbaum font-bold text-white text-2xl md:text-3xl tracking-wide">Campañas</h1>
          </div>
          <p className="font-oranienbaum text-white/40 text-sm ml-10">Marketing segmentado · Consentimiento RGPD · Sin envíos todavía</p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg"
            style={{ background: 'rgba(249,115,22,0.08)', border: '1px solid rgba(249,115,22,0.20)' }}>
            <div className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
            <span className="font-oranienbaum text-orange-400 text-xs tracking-widest uppercase">Envíos no activados todavía</span>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 rounded-lg font-oranienbaum text-sm font-semibold transition-all"
            style={{ background: ACCENT, color: '#0A0A0A' }}>
            <Icon name="Plus" size={15} />
            Nueva Campaña
          </button>
        </div>
      </div>

      {/* Aviso RGPD */}
      <div className="rounded-xl p-4 mb-6 flex items-start gap-3"
        style={{ background: 'rgba(96,165,250,0.06)', border: '1px solid rgba(96,165,250,0.15)' }}>
        <Icon name="ShieldCheck" size={16} className="text-blue-400 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-oranienbaum text-blue-400 font-semibold text-sm mb-0.5">Consentimiento y RGPD</p>
          <p className="font-oranienbaum text-white/45 text-xs leading-relaxed">
            Cada campaña respetará el consentimiento comercial del cliente. Las campañas B2C (Tienda) y B2B (Distribución) nunca se mezclarán automáticamente. Los clientes podrán darse de baja en cualquier momento.
          </p>
        </div>
      </div>

      {/* Tipos de campaña */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1 h-5 rounded-full" style={{ background: ACCENT }} />
          <Icon name="Megaphone" size={15} style={{ color: ACCENT }} />
          <span className="font-oranienbaum font-semibold text-white/80 text-sm tracking-wide uppercase">Tipos de Campaña</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {tiposCampana?.map(t => (
            <div key={t?.tipo} className="rounded-xl p-4 flex flex-col gap-2 cursor-pointer transition-all hover:scale-[1.02]"
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
              <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                style={{ background: `${t?.color}15`, border: `1px solid ${t?.color}25` }}>
                <Icon name={t?.icon} size={17} style={{ color: t?.color }} />
              </div>
              <p className="font-oranienbaum font-semibold text-white/80 text-xs tracking-wide">{t?.tipo}</p>
              <p className="font-oranienbaum text-white/30 text-xs leading-tight">{t?.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Segmentación */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
        <div className="rounded-xl p-5"
          style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1 h-5 rounded-full bg-purple-400" />
            <Icon name="Filter" size={15} className="text-purple-400" />
            <span className="font-oranienbaum font-semibold text-white/80 text-sm uppercase tracking-wide">Criterios de Segmentación</span>
          </div>
          <div className="space-y-2">
            {segmentacion?.map(s => (
              <div key={s?.campo} className="flex items-center gap-3 py-2 px-3 rounded-lg"
                style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
                <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: 'rgba(167,139,250,0.12)', border: '1px solid rgba(167,139,250,0.20)' }}>
                  <Icon name={s?.icon} size={13} className="text-purple-400" />
                </div>
                <div>
                  <p className="font-oranienbaum text-white/70 text-sm font-semibold">{s?.campo}</p>
                  <p className="font-oranienbaum text-white/30 text-xs">{s?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lista campañas vacía */}
        <div className="rounded-xl overflow-hidden"
          style={{ border: '1px solid rgba(255,255,255,0.07)' }}>
          <div className="px-4 py-3 flex items-center justify-between"
            style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
            <span className="font-oranienbaum text-white/60 text-sm font-semibold">Campañas</span>
            <div className="flex gap-1.5">
              {['Todos', 'Activas', 'Borrador', 'Finalizadas']?.map(f => (
                <button key={f} onClick={() => setTipoFiltro(f)}
                  className={`px-2.5 py-1 rounded-lg text-xs font-oranienbaum transition-all ${tipoFiltro === f ? 'font-semibold' : 'text-white/40 hover:text-white/70'}`}
                  style={tipoFiltro === f ? { background: ACCENT, color: '#0A0A0A' } : { background: 'rgba(255,255,255,0.05)' }}>
                  {f}
                </button>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center justify-center py-16"
            style={{ background: 'rgba(255,255,255,0.01)' }}>
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3"
              style={{ background: 'rgba(249,115,22,0.08)', border: '1px solid rgba(249,115,22,0.15)' }}>
              <Icon name="Megaphone" size={24} className="text-orange-400/60" />
            </div>
            <p className="font-oranienbaum text-white/40 text-sm font-semibold mb-1">Sin campañas todavía</p>
            <p className="font-oranienbaum text-white/20 text-xs text-center max-w-xs">
              Las campañas se crearán cuando la base de clientes esté migrada y los consentimientos registrados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComercialCampanas;
